import { FilterVariantProps } from '@silverfort/sf-components';
import { ServiceAccountsTuplesFilters } from './ServiceAccountsTuplesTypes';
import { PROTOCOL_DISPLAY_MAPPER } from '@silverfort-nodelibs/common/utils/consts';

export const PROTOCOL_FILTER: Omit<FilterVariantProps<string>, 'onChange'> & {
    filterKey: keyof ServiceAccountsTuplesFilters;
} = {
    filterKey: 'protocols',
    variant: 'filter',
    title: 'Protocol',
    searchable: true,
    multiple: true,
    selectedItems: [],
    items: Object.keys(PROTOCOL_DISPLAY_MAPPER).map((protocol) => ({
        value: protocol,
        title: PROTOCOL_DISPLAY_MAPPER[protocol as keyof typeof PROTOCOL_DISPLAY_MAPPER]
    }))
};

export const LAST_SEEN_FILTER: Omit<FilterVariantProps<number>, 'onChange'> & {
    filterKey: keyof ServiceAccountsTuplesFilters;
} = {
    filterKey: 'lastUsedDays',
    variant: 'filter',
    title: 'Last Seen',
    searchable: false,
    multiple: false,
    selectedItems: [],
    items: [
        { value: 1, title: 'Last day' },
        { value: 7, title: 'Last week' },
        { value: 30, title: 'Last month' },
        { value: 90, title: 'Last 3 months' }
    ]
};
